import { DomSanitizer } from '@angular/platform-browser';
import { setBlockType } from 'prosemirror-commands';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, HostListener } from '@angular/core';
import { Editor, Toolbar, nodes as basicNodes, marks } from 'ngx-editor';
import { NodeSpec, Schema } from 'prosemirror-model';
import { ArticleBlock } from '../../../../models/article';
import { hasContentInHTMLTags } from 'src/app/common/function';

@Component({
  selector: 'app-article-lead',
  templateUrl: './article-lead.component.html',
  styleUrls: ['./article-lead.component.scss']
})
export class ArticleLeadComponent implements OnInit, OnDestroy, OnChanges {

  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Input() blockElement: ArticleBlock;

  editor: Editor;
  toolbar: Toolbar = [['align_left', 'align_center', 'align_right', 'align_justify']];

  constructor(private renderer: Renderer2, private el: ElementRef, private sanitizer: DomSanitizer) { }


  ngOnInit(): void {
    this.editor = new Editor();

  }

  getcontentWithDangerHTml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.ProseMirror.NgxEditor__Content');
        this.renderer.setAttribute(editorElement, 'autofocus', 'true');
        editorElement.focus();
      }
    }, 700);
  }

  onChange(e: string) {
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
